import { SVGProps, Ref, forwardRef } from 'react';

export const ClickmeBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.34 7.799a.467.467 0 0 1 .76-.439l4.203 3.529a.467.467 0 0 1-.23.819l-1.175.178 1.739 3.01-1.038.6-1.739-3.012-.74.93a.467.467 0 0 1-.825-.21z"
                fill="#9054EA"
            />
            <path
                d="M8.517.51c5.055.217 6.866 3.626 6.977 7.138L15.5 8h-1.4c0-1.667-.42-3.184-1.316-4.26C11.924 2.71 10.476 1.9 8 1.9s-3.925.81-4.784 1.84C2.319 4.816 1.9 6.333 1.9 8s.42 3.184 1.316 4.26c.397.477.922.904 1.615 1.227l-.703 1.218C1.476 13.407.5 10.704.5 8l.006-.352C.62 4.02 2.55.5 8 .5z"
                fill="#9054EA"
            />
            <path
                d="M8.327 3.257c3.095.132 4.27 2.155 4.408 4.299L12.75 8h-1.4c0-.979-.248-1.809-.714-2.37-.43-.514-1.192-.98-2.636-.98s-2.206.465-2.636.98C4.897 6.192 4.65 7.02 4.65 8c0 .979.248 1.809.714 2.37.206.246.489.481.886.66l-.702 1.216C3.868 11.424 3.25 9.712 3.25 8l.015-.444C3.408 5.338 4.66 3.25 8 3.25z"
                fill="#9054EA"
            />
        </g>
    </svg>
));
ClickmeBrandSize16Glyph.displayName = 'ClickmeBrandSize16Glyph';
